<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="snackbar mt-2 py-3 px-4">
    <v-list-item>
      <v-list-item-icon>
        <v-icon :style="{ color: `var(--v-${snackbar.type}-base)` }">{{ icon }}</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="snackbar.message.text || $t(snackbar.message.i18nKey, snackbar.message.params)"></span>
      </v-list-item-content>

      <v-list-item-action v-if="snackbar.dismissible">
        <v-btn color="primary" text @click="dismissSnackbar">
          {{ $t('buttons.close') }}
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'EcsSnackbar',
  data() {
    return {
      messageIcons: {
        info: 'mdi-information-outline',
        success: 'mdi-check-circle-outline',
        error: 'mdi-close-octagon-outline',
        warning: 'mdi-alert-outline'
      },
      timeout: null
    };
  },
  props: {
    snackbar: {
      type: Object,
      required: true
    },
    themeMode: {
      type: Boolean,
      required: true
    }
  },

  created() {
    if (this.snackbar.timeout > 0) {
      this.timeout = setTimeout(() => {
        this.dismissSnackbar();
      }, this.snackbar.timeout);
    }
  },

  computed: {
    icon() {
      return this.messageIcons[this.snackbar.type];
    }
  },

  methods: {
    ...mapActions(['removeSnackbarMessage']),

    dismissSnackbar() {
      clearTimeout(this.timeout);
      this.removeSnackbarMessage(this.snackbar.id);
      this.timeout = null;
    }
  }
};
</script>

<style scoped>
.snackbar {
  display: flex;
  align-items: center;
  min-width: 250px;
  border-radius: 8px;
  height: 88px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  font-size: 0.875rem;
  background: var(--v-surface-base);
  margin: 16px;
}
</style>
